// MessagePanelTop.js
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';
import { withTranslation } from 'react-i18next';

import MessagePanelTop from '../component/MessagePanelTop.jsx';

import { MASQUED_PHRASES } from '../RemoteConfigKeys.js';
import login from '../action/login.js';
import getMeData from '../selector/getMeData.js';
import getOperationData from '../selector/getOperationData.js';
import getMessageData from '../selector/getMessageData.js';
import getUserData from '../selector/getUserData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getMessageDataWithVariable, {
  VariableName,
} from '../selector/getMessageDataWithVariable.js';
import toggleModal from '../action/toggleModal.js';
import { breakpoint } from '../style/variables.js';

const mapStateToProps = (state, { id }) => {
  const meUsername = getMeData(state, 'username');
  const userId = getMessageData(state, id, 'senderId');
  const deviceWidth = getOperationData(state, ['device'], 'width');
  const isOnDesktop = deviceWidth > breakpoint.mobile;
  return {
    messageId: id,
    userId,
    username: getUserData(state, userId, 'username'),
    hashtags: getMessageData(state, id, 'hashtags'),
    originalTitle: getMessageDataWithVariable(
      state,
      id,
      'originalTitle',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    storyCaption: getMessageDataWithVariable(
      state,
      id,
      'captionText',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    originalCaptionText: getMessageDataWithVariable(
      state,
      id,
      'originalCaptionText',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    hasTranslation: getMessageData(state, id, 'hasTranslation'),
    postedAtUnix: getMessageData(state, id, 'postedAtUnix'),
    forbiddenWords: getRemoteConfigData(state, MASQUED_PHRASES),
    isOnline: getUserData(state, userId, 'isOnline'),
    isLiveStreaming: getLiveStreamData(state, [userId], 'isLiveStreaming'),
    isOnDesktop,
    shouldFetchMessageTranslation: true, // For withFetchTranslation
    currentLanguage: getOperationData(state, ['config'], 'language'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleModal: ({ modalId, payload, isOpen }) =>
      dispatch(toggleModal({ modalId, payload, isOpen })),
    goBack: () => dispatch(goBack()),
    login: () => dispatch(login()),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(MessagePanelTop)
);
